import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-forest text-white/90">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          <div>
            <div className="mb-4">
              <img src="/logo-oymer-real.png" alt="Oymer - Vida Divina" className="h-16 w-auto object-contain brightness-0 invert opacity-90" />
            </div>
            <p className="font-body text-sm text-white/60 leading-relaxed max-w-xs">
              Distribuidor autorizado de Vida Divina. Productos 100% naturales para tu bienestar y salud integral.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Navegación</h4>
            <div className="space-y-3">
              <Link to="/" className="block font-body text-sm text-white/60 hover:text-terracotta transition-colors duration-200">Inicio</Link>
              <Link to="/catalogo" className="block font-body text-sm text-white/60 hover:text-terracotta transition-colors duration-200">Catálogo</Link>
              <Link to="/oportunidad" className="block font-body text-sm text-white/60 hover:text-terracotta transition-colors duration-200">Oportunidad</Link>
              <Link to="/contacto" className="block font-body text-sm text-white/60 hover:text-terracotta transition-colors duration-200">Contacto</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Contacto</h4>
            <div className="space-y-3">
              <a href="https://wa.me/19146730325" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 font-body text-sm text-white/60 hover:text-terracotta transition-colors duration-200">
                <Phone size={16} strokeWidth={1.5} /> +1 (914) 673-0325
              </a>
              <a href="mailto:oymer1991@icloud.com" className="flex items-center gap-2 font-body text-sm text-white/60 hover:text-terracotta transition-colors duration-200">
                <Mail size={16} strokeWidth={1.5} /> oymer1991@icloud.com
              </a>
              <p className="flex items-center gap-2 font-body text-sm text-white/60">
                <MapPin size={16} strokeWidth={1.5} /> Estados Unidos
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-white/40">
            © {new Date().getFullYear()} Oymer - Distribuidor Autorizado Vida Divina. Todos los derechos reservados.
          </p>
          <Link to="/admin/login" className="font-body text-xs text-white/20 hover:text-white/40 transition-colors duration-200">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
